import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { TradeAdminRoutingModule } from '../../../tradeAdmin-routing.module';
import { EnitComplainceRoutingModule } from '../../../eComplaince-routing.module'
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { SharedModule } from '../../../../../shared/shared.module'
import { CtclModule } from '../../../EnitTrade/ctcl/ctcl.module';

//     <=========== Complaince Modules Below ===========>

//import { PreviousQuarterMlaiListComponent } from './EnitCompliance/previous-quarter-mlai-list/previous-quarter-mlai-list.component';



// import {CyberSecurityAdminListComponent} from './EnitCompliance/cyber-security-admin-list/cyber-security-admin-list.component'

import { AgGridModule } from 'ag-grid-angular';

//P2P


//Cyber & System


//import { ShareHoldingCorporateComponentComponent } from './EnitCompliance/share-holding-corporate-component/share-holding-corporate-component.component';
import { BaseChartDirective, provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { HighchartsChartModule } from 'highcharts-angular';
import { ClntFundsAdminEligiblityComponent } from './clnt-funds-admin-eligiblity/clnt-funds-admin-eligiblity.component';
import { ClntFundsAddEligiblityUserComponent } from './clnt-funds-add-eligiblity-user/clnt-funds-add-eligiblity-user.component';
import { ClientFundsReadOnlyComponent } from './client-funds-read-only/client-funds-read-only.component';
import { ClientFundsAdminReportComponent } from './client-funds-admin-report/client-funds-admin-report.component';




@NgModule({
  declarations: [
    
    //     <=========== Complaince Modules Below ===========>
    
    // <----------------COLO MODULES ------------------>
    
    // <------------- HalfYeraly Networth Module ------------->
    //  <----------  Advertisement Module ------------->


    // <---------- Change in Address ----------->


    // <----------  Annual Return for Global Access ---------->
    ClientFundsAdminReportComponent,
    ClientFundsReadOnlyComponent,
    ClntFundsAddEligiblityUserComponent,
    ClntFundsAdminEligiblityComponent,


  ],
  imports: [
    
    CommonModule,
    FormsModule,
    DataTablesModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    BsDatepickerModule,
    SharedModule,
    CtclModule,
    AgGridModule,
    BaseChartDirective,
    HighchartsChartModule
  ]
})
export class MonitoringClientFundAdmin { }
